export default {
    name: 'task Management',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getTask: async (context,id) => {
            return await axios.get(`${synergy4}tasks/sprint/${id}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err
            })
        },
        getTagTypeByID: async (context,id) => {
            return await axios.get(`${synergy4}tags/type/${id}`)
            .then(({data})=>data)
            .catch((err) => errorHandler.tomcatError(err))
        },
        createTasks: async (context,payload) => {
            const url = `${synergy4}tasks/create`;
            return await context.dispatch('sendRequest',{url,payload})
        },
        updateTask: async (context,payload) => {
            const url = `${synergy4}tasks/update-status`;
            return await context.dispatch('sendRequest',{url,payload})
        },


        fetchAllTags: async (context) => {
            return await axios.get(`${synergy4}devtasks-association/all-Dev-Tags`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        fetchTagsByTaskId: async (context,id) => {
            return await axios.get(`${synergy4}devtasks-association/TagByDevTaskId/${id}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        addTagToTask: async (context,payload) => {
            const url = `${synergy4}devtasks-association/create-dev-tag`;
            return await context.dispatch('sendRequest',{url,payload})
        },

        fetchOverlltag: async (context) => {
            return await axios.get(`${ticketApi}ticket/reports/overAll-tag-reports`)
                .then(({data})=>data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },
        fetchPerSupportAgent: async (context,id) => {
            return await axios.get(`${ticketApi}ticket/reports/report-PerSupportAgent?createUserID=${id}`)
                .then(({data})=>data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },
        fetchNotificationInformation: async (context,id) => {
            return await axios.get(`${ticketApi}notifications/user/${id}`)
                .then(({data})=>data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },
        markAsRead: async (context,payload) => {
            return await axios.post(`${ticketApi}notifications/${payload.noteId}/read`)
                .then(({data})=>data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },

        // Task Notes Actions
        fetchTaskNotes: async (context, taskId) => {
            return await axios.get(`${synergy4}api/dev-task-notes/task/${taskId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },

        createTaskNote: async (context, payload) => {
            return await axios.post(`${synergy4}api/dev-task-notes/add?taskId=${payload.taskId}&noteContent=${payload.noteContent}&userId=${payload.userId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err);
                    throw err;
                })
        },
    }
}
